





















import Vue, { PropType } from 'vue'
import { Widget } from '../widgets/base'
import BaseDialog from './BaseDialog.vue'

export default Vue.extend({
  components: {
    BaseDialog
  },
  props: {
    isVisible: {
      type: Boolean,
      required: true,
      default: false
    },
    widget: {
      type: Object as PropType<Widget>,
      required: true
    }
  },
  data() {
    return {
      layoutName: '',
      currentWidget: {}
    }
  },
  mounted() {
    this.currentWidget = this.widget
  },
  methods: {
    onDelete() {
      this.$emit('onDelete', this.currentWidget)
    },
    closeDialog() {
      this.$emit('closeDialog')
    }
  }
})
